module.exports = __webpack_public_path__ + "static/media/SpaceMono-BoldItalic.97244dda.ttf";